__turbopack_context__.v({
  "footerColumn": "fSE7Va_footerColumn",
  "footerRow": "fSE7Va_footerRow",
  "footerSection": "fSE7Va_footerSection",
});
